// extracted by mini-css-extract-plugin
export var infoRow = "_sv-2";
export var labelContainer = "_sv-0";
export var rightInfo = "_sv-1";